export type AppEnvironment = 'prod' | 'dev';

const isProd = process.env.GATSBY_ENVIRONMENT === 'prod';

const prodConfig = {
  apiUrl:
    'https://api-staging.schoolnetindia.tech/sn-website-form/website-form',
};

const devConfig = {
  apiUrl:
    'https://api-staging.schoolnetindia.tech/sn-website-form/website-form',
};

export const config = {
  environment: (isProd ? 'prod' : 'dev') as AppEnvironment,
  ...(isProd ? prodConfig : devConfig),
};
